
export class LocalUserAuthenticationCreateModel {
  userId: string;
}
